import { render, staticRenderFns } from "./ReportImageDamageDetailCard.vue?vue&type=template&id=647d7464"
import script from "./ReportImageDamageDetailCard.vue?vue&type=script&lang=ts"
export * from "./ReportImageDamageDetailCard.vue?vue&type=script&lang=ts"
import style0 from "./ReportImageDamageDetailCard.vue?vue&type=style&index=0&id=647d7464&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports